/* @flow */

import $ from 'jquery';

const efeitosIniciais = () => {
    const wow = new global.WOW({ animateClass: 'animated', offset: 0, mobile: false });
    wow.init();

    global.NProgress.inc(0.2);

    setTimeout(() => {
        global.NProgress.done();
        $('.fade').removeClass('out');
    }, 1000);
};

export default efeitosIniciais;



// WEBPACK FOOTER //
// ./app/admin/login/efeitos-iniciais.js